import { reactive } from 'vue';
const state = reactive({
  alerts: [],
  currentAlert: { message: null, level: null, show: false },
});

export default function useAlerts() {
  function addAlert(message, level, timeout) {
    if (state.alerts.some((alert) => alert.message === message)) return;
    state.alerts.push({ message, level, timeout });
    pushNewAlert();
  }

  function pushNewAlert() {
    if (state.currentAlert.message) return;
    if (state.alerts.length === 0) return;
    const alert = state.alerts.shift();
    state.currentAlert.message = alert.message;
    state.currentAlert.level = alert.level;
    state.currentAlert.show = true;
    setTimeout(() => {
      removeAlert();
    }, alert.timeout * 1000 || 5000);
  }

  function removeAlert() {
    state.currentAlert.show = false;
    setTimeout(() => {
      state.currentAlert.message = null;
      state.currentAlert.level = null;
      pushNewAlert();
    }, 500);
  }

  return {
    alerts: state.alerts,
    addAlert,
    currentAlert: state.currentAlert,
  };
}
